import { SettingOutlined } from "@ant-design/icons";
import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as FieldSettingsPage } from "routes/_authenticated/$tenantSlug/_layout/setting/_layout/field";
import { Route as GeneralSettingsPage } from "routes/_authenticated/$tenantSlug/_layout/setting/_layout/general";
import { Route as PlanSettingsPage } from "routes/_authenticated/$tenantSlug/_layout/setting/_layout/plan";
import { Route as TagSettingsPage } from "routes/_authenticated/$tenantSlug/_layout/setting/_layout/tag";
import { Route as TrackingSettingsPage } from "routes/_authenticated/$tenantSlug/_layout/setting/_layout/tracking";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/setting/")({
    component: SettingsPage,
    staticData: {
        permissions: [
            PermissionEnum.SettingGeneral,
            //PermissionEnum.SettingUser
            PermissionEnum.SettingTracking,
            PermissionEnum.SettingField,
            PermissionEnum.SettingTags,
            PermissionEnum.SettingPlan,
        ],
        showInSideMenu: true,
        label: "pages.setting.title",
        icon: <SettingOutlined />,
        sort: 9,
        redirects: [
            GeneralSettingsPage,
            //UserSettingsPage, TODO uncomment after finish User Settings
            TrackingSettingsPage,
            FieldSettingsPage,
            TagSettingsPage,
            PlanSettingsPage,
        ],
        defaultRedirect: GeneralSettingsPage,
    },
});
function SettingsPage() {
    return <RedirectPage />;
}
